"use strict";
exports.__esModule = true;
// eslint-disable-next-line import/prefer-default-export
var useTheme_1 = require("./useTheme");
exports.useTheme = useTheme_1["default"];
//# sourceMappingURL=index.js.map